/* global axios */
import ApiClient from '../ApiClient';

// The agent-side copilot on Teletel's own endpoints. Threads belong to the
// signed-in agent; the server never returns anyone else's.
class TeletelCopilotAPI extends ApiClient {
  constructor() {
    super('teletel/copilot-threads', { accountScoped: true });
  }

  listThreads() {
    return axios.get(this.url);
  }

  createThread(assistantId = null) {
    return axios.post(this.url, { assistant_id: assistantId });
  }

  listMessages(threadId) {
    return axios.get(`${this.url}/${threadId}/messages`);
  }

  ask(threadId, content, conversationId = null) {
    return axios.post(`${this.url}/${threadId}/messages`, {
      content,
      conversation_id: conversationId,
    });
  }
}

export default new TeletelCopilotAPI();
